import RestrictionsStrategyBase from './restrictions_strategy_base';
import _ from '../../../utils/underscore';
import Event from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';
import Store from '../../../utils/store';
import IRestrictionsPool from '../pool/restrictions_pool_interface';

const RESTRICTION_STORAGE_KEY = 'last-restrictions';
export default class AuthorizedRestrictionsStrategy extends RestrictionsStrategyBase {
  static CLASS = 'AuthorizedRestrictionsStrategy';

  init(params) {
    super.init(params);
    this._subscribe();
  }

  private _restrictionsPool: IRestrictionsPool = null;

  public getRestrictionsPool(): IRestrictionsPool {
    if(!this._restrictionsPool) {
      this._loadRestrictions();
    }

    return this._restrictionsPool;
  }

  private _subscribe(): void {
    Event.on(SYSTEM_EVENTS.SESSION_EVENT_UPDATERESTRICTION_RECEIVED, this._onUpdateRestrictions, this);

    Event.on(SYSTEM_EVENTS.APP_RESUMED, () => {
      this._loadRestrictions(); // update restrictions cache
    }, this);

    Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
      if (false === this._serviceFactory.oAuth2Service().isAuthorized()) {
        Store.del(RESTRICTION_STORAGE_KEY);
      }
      this._loadRestrictions();
    });
  }


  //Create restriction pool with a new data restrictions and save in in local storage
  private _onUpdateRestrictions(data: any): void {
    this._restrictionsPool = this._createRestrictionsPool(data);
    Store.set(RESTRICTION_STORAGE_KEY, JSON.stringify(data));
    Event.fire(SYSTEM_EVENTS.RESTRICTIONS_CHANGED);
  }

  //Load restrictions from local storage or token and create new restriction pool
  private _loadRestrictions(): void {
    // check if there are restrictions in local storage
    let restrictionJSON = Store.get(RESTRICTION_STORAGE_KEY);
    if (!restrictionJSON) {
      restrictionJSON = this._serviceFactory.oAuth2Service().extractTokenProperty('restrictions');
    }
    this._createRestrictionsByAction(restrictionJSON);
  }


  //Create new restriction pool from restriction json data
  private _createRestrictionsByAction(restrictionJSON: string): void {
    const restrictionsData = _.safeJSON(restrictionJSON, null);

    let restrictionsByAction = [];
    if(restrictionsData) {
      if (_.isArray(restrictionsData)) {
        restrictionsByAction = restrictionsData;
      } else {
        restrictionsByAction.push(restrictionsData)
      }
    }
    this._restrictionsPool = this._createRestrictionsPool(restrictionsByAction);
  }
}